import * as z from 'zod';
import { SchemaSection } from '@rossum/api-client/schemas';
import { getFlattenSchemaFields } from '../../../../schemas/getFlattenSchemaFields';

/** Which section holds a field, for suggesters that need to place it. */
export const findSectionIdForField = (
  schemaContent: SchemaSection[],
  fieldSchemaId: string
): string => {
  const [section] =
    getFlattenSchemaFields(schemaContent)[fieldSchemaId]?.path ?? [];
  return section?.id ?? schemaContent[0]?.id ?? '';
};

export const customMatchingConfigurationSchema = z.object({
  // catch(undefined) mostly to fallback from null to optional
  type: z.string().optional().catch(undefined),
  hook_interface: z.string().optional().catch(undefined),
  configuration: z.record(z.unknown()).default({}),
});
